export default __webpack_public_path__ + "static/media/faqimage7.ba6e422e.jpg";